var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.421,
    height: 15,
    viewBox: "0 0 13.421 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Polygon_2",
    "data-name": "Polygon 2",
    d: "M6.627,1.562a1,1,0,0,1,1.746,0l5.8,10.371a1,1,0,0,1-.873,1.488H1.7a1,1,0,0,1-.873-1.488Z",
    transform: "translate(13.421) rotate(90)",
    fill: "#0047ff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBlue);
export default __webpack_public_path__ + "static/media/arrow-blue.8c2cdbe86801f8ce213eeb17558b28f4.svg";
export { ForwardRef as ReactComponent };